import { useMemo } from "react"
import { NavLink, Outlet } from "react-router"

import { NavbarTabList, navbarTabClass } from "@/components/NavbarTabs"
import { useNavbarLeftAction, usePageTitle } from "@/layouts/pageChrome"

const TABS = [
  { to: "/activity/logs", label: "Sync Logs" },
  { to: "/activity/postback", label: "Postback" },
  { to: "/activity/campaign-jobs", label: "Campaign Jobs" },
] as const

export default function ActivityPage() {
  usePageTitle("", "Activity")

  const navbarTabs = useMemo(
    () => (
      <NavbarTabList>
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) => navbarTabClass(isActive)}
          >
            {tab.label}
          </NavLink>
        ))}
      </NavbarTabList>
    ),
    [],
  )
  useNavbarLeftAction(navbarTabs)

  return (
    <div className="rounded-xl border border-[#4a4a4a] bg-[#2d2d2d] p-4 shadow-md sm:p-6">
      <Outlet />
    </div>
  )
}
